// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"67b99310","937":"d78befcb"}[chunkId] + ".chunk.js";
};